import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom'; // ✅ useHistory instead of useNavigate
import { CryptoTrade } from './page';
import NotFound from '../NotFound';
import { SocketUrl } from '../services/api';
import { io } from 'socket.io-client';
import { toast } from 'react-toastify';
import { exChangeSocket } from '../../utils/socket';

const ExchangePairValidateMiddleware = () => {
    // const socket = exChangeSocket
    const location = useLocation();
    const history = useHistory(); // ✅ history object for navigation

    const [loader, set_loader] = useState(true);
    const [pairExist, set_pairExist] = useState(true);
    const [pair, set_pair] = useState("");
    const [isConnected, set_isConnected] = useState(false);
    const [portfolio, set_portfolio] = useState(0);

    // Create socket connection once
    const socket = useMemo(() => {
        console.log(`Creating socket connection to: ${SocketUrl}`);
        const options = { autoConnect: true, transports: ["websocket"] };
        const token = localStorage.getItem("jwtToken");
        if (token) {
            options.query = { token };
        }
        return io(SocketUrl, options);
    }, []);

    // Handle socket connection events
    useEffect(() => {
        socket.on("connect", () => {
            console.log("Socket connected ✅", socket.id);
            set_isConnected(true);
        });

        socket.on("disconnect", (reason) => {
            console.log("Socket disconnected ❌", reason);
            set_isConnected(false);
        });

        socket.on("401", (reason) => {
            console.log("Socket disconnected 401 ❌", reason);
            set_isConnected(false);
        });

        return () => {
            socket.disconnect();
        };
    }, [socket]);

    let pathParts = location.pathname.split('/');
    pathParts = pathParts.slice(2).filter(part => part !== '');

    const ValidatePair = (pairValue) => {
        set_loader(true);
        socket.emit("validate_pair", { pair: pairValue }, (response) => {            
            if (response.status && response.code === 200) {
                set_pair(pairValue);
                set_pairExist(true);
            } else {
                toast.error("Invalid pair");
                set_pairExist(false);
            }
            set_loader(false);
        });
    };

    const get_portfolio = () => {
        socket.emit("get-portfolio", {}, (response) => {            
            if (response.status && response.code === 200) {
                set_portfolio(response.data);
            } else {
                toast.error("Error fetching portfolio");
            }
        });
    };

    const DefaultPair = () => {
        set_loader(true);
        socket.emit("get_default_pair", {}, (response) => {
            console.log("get_default_pair response:", response);
            if (response.status && response.code === 200) {
                set_pair(response.data);
                set_pairExist(true);

                // ✅ Update URL with default pair in v5
                history.replace(`/exchange/${response.data}`);
            } else {
                toast.error("No default pair found");
                set_pairExist(false);
            }
            set_loader(false);
        });
    };

    useEffect(() => {
        if (!isConnected) {
            console.log("Waiting for socket connection...");
            return;
        }

        console.log("Path parts:", pathParts);

        if (pathParts.length === 0) {
            DefaultPair();
        } else if (pathParts.length === 2) {
            ValidatePair(`${pathParts[0]}/${pathParts[1]}`);
        } else {
            set_loader(false);
            set_pairExist(false);
        }
    }, [location.pathname, isConnected]);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            get_portfolio();
        }
    }, [isConnected]);

    return pairExist
        ? <CryptoTrade pair={pair} socket={socket} portfolio={portfolio} />
        : <NotFound />;
};

export { ExchangePairValidateMiddleware };
